import React from 'react'
import ReactDOM from 'react-dom'
import App from './app'
import 'style/main.scss'

ReactDOM.render(<App />, document.getElementById('root'))
